export default __webpack_public_path__ + "static/media/caroussel-4.80c5365c.png";